// extracted by mini-css-extract-plugin
export var adjacentSlide = "_sw-9";
export var arrowButtonContainer = "_sw-5";
export var arrowButtonIcon = "_sw-6";
export var carouselArrowButton = "_sw-2";
export var carouselElementContainer = "_sw-1";
export var currentSlide = "_sw-8";
export var left = "_sw-3";
export var otherSlide = "_sw-a";
export var productCarouselContainer = "_sw-0";
export var right = "_sw-4";
export var sliderOverflow = "_sw-7";